import React from "react";
import { PathArray } from "common/utils/formStructure/types";
import { Checkbox } from "../../../../../../../Inputs/react-hook-form";
import {
  getUiSchemaPropertyFormPath,
  useBuilderFormContext,
} from "../../../form/form";

type RandomizeOptionOrderCheckboxProps = {
  fieldPath: PathArray;
  isReadOnly: boolean;
};

/**
 * For dropdown fields, this checkbox allows the user to randomize the order of
 * the options when the form is loaded.
 */
export const RandomizeOptionOrderCheckbox = (
  props: RandomizeOptionOrderCheckboxProps,
) => {
  const { fieldPath, isReadOnly } = props;
  const { control } = useBuilderFormContext();

  const randomizeOptionOrderPropertyFormPath = getUiSchemaPropertyFormPath(
    fieldPath,
    "randomizeOptionOrder",
  );

  return (
    <Checkbox
      control={control}
      name={randomizeOptionOrderPropertyFormPath}
      label="Randomize display order of dropdown options"
      disabled={isReadOnly}
    />
  );
};
